<template>
  <div class="wall-root">
    <header class="wall-topbar">
      <div>
        <h1 class="wall-title mb-0">监考监控墙</h1>
        <div class="wall-subtitle small">
          {{ examTitle || `考试 #${wallExamId}` }} · 第 {{ wallTotalPages ? wallPage + 1 : 0 }} / {{ wallTotalPages || 0 }} 页 · 本页
          {{ wallStudents.length }} 人 · 共 {{ wallTotal }} 人
        </div>
      </div>
      <div class="d-flex flex-wrap align-items-center gap-2">
        <button type="button" class="btn btn-sm btn-outline-secondary" :disabled="wallPage <= 0" @click="goPage(wallPage - 1)">
          上一页
        </button>
        <button
          type="button"
          class="btn btn-sm btn-outline-secondary"
          :disabled="wallPage >= wallTotalPages - 1"
          @click="goPage(wallPage + 1)"
        >
          下一页
        </button>
        <span class="wall-refresh-hint small">每 {{ pollSeconds }} 秒自动刷新</span>
        <button type="button" class="btn btn-sm btn-light" @click="fetchWall(false)">刷新</button>
        <button type="button" class="btn btn-sm btn-primary" @click="goBackProctor">返回监考系统</button>
      </div>
    </header>
    <p class="wall-tip small">
      独立页面便于多显示器、多窗口同时打开：复制地址栏链接，将 <code>page=</code> 改为 0、1、2… 即可查看不同学员组（每页最多 50 人）。
    </p>
    <div class="wall-grid">
      <div v-for="s in wallStudents" :key="s.recordId" class="wall-card">
        <div class="wall-card-head">
          <span class="wall-name">{{ s.username || '学员' }}</span>
          <span class="wall-badge">{{ recordStatusText(s.status) }}</span>
        </div>
        <div class="wall-thumb">
          <img v-if="photoSrc(s)" :src="photoSrc(s)" alt="" class="wall-img" />
          <div v-else class="wall-placeholder">无画面</div>
        </div>
        <div class="wall-meta">切屏 {{ s.screenCount != null ? s.screenCount : 0 }}</div>
      </div>
      <div v-if="wallStudents.length === 0" class="wall-empty">本页暂无数据或本场无学员</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TeacherProctorWallView',
  data() {
    return {
      wallExamId: null,
      wallPage: 0,
      wallPageSize: 50,
      wallStudents: [],
      wallTotal: 0,
      wallTotalPages: 0,
      examTitle: '',
      pollTimer: null,
      pollSeconds: 1
    }
  },
  mounted() {
    this.parseWallQuery()
    if (!this.wallExamId) {
      window.alert('缺少考试参数，请从监考系统中打开本页')
      window.location.hash = '#/teacher/proctor'
      return
    }
    const userStr = localStorage.getItem('exam_user')
    if (!userStr) {
      window.location.hash = '#/'
      return
    }
    try {
      const u = JSON.parse(userStr)
      if (String(u.role || '').toLowerCase() !== 'teacher') {
        window.location.hash = '#/'
        return
      }
    } catch (e) {
      window.location.hash = '#/'
      return
    }
    this.loadExamTitle()
    this.fetchWall(false)
    this.startPoll()
    window.addEventListener('hashchange', this.onHashChange)
  },
  beforeUnmount() {
    window.removeEventListener('hashchange', this.onHashChange)
    this.stopPoll()
  },
  methods: {
    authHeaders(extra = {}) {
      return { 'X-Role': 'teacher', ...extra }
    },
    parseWallQuery() {
      const hash = window.location.hash || ''
      const qIdx = hash.indexOf('?')
      const q = qIdx >= 0 ? new URLSearchParams(hash.slice(qIdx + 1)) : new URLSearchParams()
      const eid = q.get('examId')
      const pg = q.get('page')
      this.wallExamId = eid != null && eid !== '' ? Number(eid) : null
      this.wallPage = pg != null && pg !== '' ? Math.max(0, Number(pg)) : 0
      if (!Number.isFinite(this.wallExamId)) this.wallExamId = null
      if (!Number.isFinite(this.wallPage)) this.wallPage = 0
    },
    onHashChange() {
      this.parseWallQuery()
      if (this.wallExamId) this.fetchWall(true)
    },
    loadExamTitle() {
      fetch(`/api/crud/exam/${this.wallExamId}`)
        .then((r) => r.json())
        .then((res) => {
          const ex = res && res.data
          if (ex && ex.examName) this.examTitle = ex.examName
        })
        .catch(() => {})
    },
    goPage(p) {
      const max = Math.max(0, this.wallTotalPages - 1)
      const n = Math.min(Math.max(0, p), max)
      if (n === this.wallPage) return
      window.location.hash = `#/teacher/proctor-wall?examId=${this.wallExamId}&page=${n}`
    },
    goBackProctor() {
      window.location.hash = '#/teacher/proctor'
    },
    startPoll() {
      this.stopPoll()
      this.pollTimer = setInterval(() => this.fetchWall(true), this.pollSeconds * 1000)
    },
    stopPoll() {
      if (this.pollTimer) clearInterval(this.pollTimer)
      this.pollTimer = null
    },
    fetchWall(silent) {
      if (this.wallExamId == null) return
      const params = new URLSearchParams({
        page: String(this.wallPage),
        size: String(this.wallPageSize)
      })
      fetch(`/api/teacher/exam-monitor/exam/${this.wallExamId}/live?${params.toString()}`, {
        headers: this.authHeaders()
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.code === 200 && res.data) {
            const d = res.data
            this.wallStudents = d.content || []
            this.wallTotal = Number(d.total) || 0
            this.wallTotalPages = Number(d.totalPages) || 0
            if (typeof d.page === 'number') this.wallPage = d.page
            return
          }
          if (!silent) window.alert(res.message || '加载失败')
        })
        .catch(() => {
          if (!silent) window.alert('网络错误')
        })
    },
    photoSrc(s) {
      const p = s && (s.monitorPhotoPreview || s.monitorPhoto)
      if (!p || !String(p).trim()) return ''
      const t = String(p).trim()
      if (t.startsWith('data:image')) return t
      return `data:image/jpeg;base64,${t}`
    },
    recordStatusText(st) {
      const s = String(st || '').toUpperCase()
      if (s === 'ASSIGNED') return '已分配'
      if (s === 'EXAMING') return '作答中'
      if (s === 'COMMIT') return '已交卷'
      if (s === 'FORCE_END') return '强制交卷'
      if (s === 'GRADED') return '已阅卷'
      return st || '—'
    }
  }
}
</script>

<style scoped>
.wall-root {
  min-height: 100vh;
  padding: 12px 16px 20px;
  background: linear-gradient(160deg, #0f172a 0%, #1e293b 40%, #0f172a 100%);
  color: #e2e8f0;
}
.wall-topbar {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
  padding: 12px 14px;
  border-radius: 12px;
  background: rgba(30, 41, 59, 0.85);
  border: 1px solid rgba(148, 163, 184, 0.25);
}
.wall-title {
  font-size: 1.35rem;
  font-weight: 800 !important;
  color: #ffffff !important;
  letter-spacing: 0.02em;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.45);
}
.wall-subtitle {
  margin-top: 6px;
  color: #e2e8f0;
  font-weight: 500;
}
.wall-refresh-hint {
  color: #f1f5f9;
  font-weight: 500;
  white-space: nowrap;
}
.wall-tip {
  margin-bottom: 10px;
  color: #cbd5e1;
  line-height: 1.55;
}
.wall-tip code {
  color: #7dd3fc;
  background: rgba(15, 23, 42, 0.75);
  border: 1px solid rgba(125, 211, 252, 0.35);
  padding: 1px 6px;
  border-radius: 4px;
}
.wall-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(118px, 1fr));
  gap: 8px;
}
.wall-card {
  border-radius: 10px;
  border: 1px solid rgba(148, 163, 184, 0.2);
  background: rgba(15, 23, 42, 0.65);
  padding: 6px;
  overflow: hidden;
}
.wall-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  margin-bottom: 4px;
  font-size: 11px;
}
.wall-name {
  font-weight: 600;
  color: #f1f5f9;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}
.wall-badge {
  flex-shrink: 0;
  font-size: 10px;
  padding: 1px 5px;
  border-radius: 4px;
  background: rgba(71, 85, 105, 0.9);
  color: #e2e8f0;
}
.wall-thumb {
  aspect-ratio: 4 / 3;
  border-radius: 6px;
  overflow: hidden;
  background: #020617;
  border: 1px solid rgba(51, 65, 85, 0.6);
}
.wall-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.wall-placeholder {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  color: #64748b;
}
.wall-meta {
  margin-top: 4px;
  font-size: 10px;
  color: #94a3b8;
}
.wall-empty {
  grid-column: 1 / -1;
  text-align: center;
  padding: 24px;
  color: #cbd5e1;
  font-size: 0.95rem;
}
.wall-topbar :deep(.btn-outline-secondary) {
  color: #e2e8f0;
  border-color: rgba(148, 163, 184, 0.65);
  background: rgba(30, 41, 59, 0.5);
}
.wall-topbar :deep(.btn-outline-secondary:hover) {
  color: #0f172a;
  background: #e2e8f0;
  border-color: #e2e8f0;
}
.wall-topbar :deep(.btn-outline-secondary:disabled) {
  color: #64748b;
  border-color: rgba(100, 116, 139, 0.4);
  background: transparent;
}
</style>
